var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGraphHorizontal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_409_2566)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.9166 91.6666H2.0834C0.932813 91.6666 0 90.734 0 89.5834C0 88.4328 0.932813 87.5 2.0834 87.5H97.9168C99.0674 87.5 100 88.4328 100 89.5834C100 90.734 99.0672 91.6666 97.9166 91.6666Z",
    fill: "#334155"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4167 100C9.26606 100 8.33325 99.0672 8.33325 97.9166V2.0834C8.33345 0.932813 9.26606 0 10.4167 0C11.5672 0 12.5 0.932813 12.5 2.0834V97.9168C12.5 99.0672 11.5672 100 10.4167 100Z",
    fill: "#334155"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9167 62.5H60.4167C61.5672 62.5 62.5 63.4328 62.5 64.5834V77.0834C62.5 78.234 61.5672 79.1668 60.4167 79.1668H22.9167C21.7661 79.1668 20.8333 78.234 20.8333 77.0834V64.5834C20.8334 63.4328 21.7661 62.5 22.9167 62.5Z",
    fill: "#4CAF50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9167 12.5H72.9166C74.0672 12.5 75 13.4328 75 14.5834V27.0834C75 28.234 74.0672 29.1668 72.9166 29.1668H22.9167C21.7661 29.1668 20.8333 28.234 20.8333 27.0834V14.5834C20.8334 13.4328 21.7661 12.5 22.9167 12.5Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9167 37.5H93.75C94.9006 37.5 95.8334 38.4328 95.8334 39.5834V52.0834C95.8334 53.234 94.9006 54.1668 93.75 54.1668H22.9167C21.7661 54.1668 20.8333 53.234 20.8333 52.0834V39.5834C20.8334 38.4328 21.7661 37.5 22.9167 37.5Z",
    fill: "#FFC107"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_409_2566"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphHorizontal);
export default __webpack_public_path__ + "static/media/graph-horizontal.1c5ead1e2bb1e9fb93dc82df89df1730.svg";
export { ForwardRef as ReactComponent };